module.exports = __webpack_public_path__ + "img/frame (15).b81ef7f6.jpg";